import DateUtils from '@shared/utils/date';
import EventUtils from '@shared/utils/events';
import eventsRequest from '../events/eventsRequest';
import incomingEventsRequest from './incomingEventsRequest';
import nextHoursEventsRequest from '../events/nextHoursEventsRequest';
import { EventMap, IEventObservable } from '@shared/types/interfaces/event';
import { Observable } from 'rxjs';
import { store } from '@shared/store/store';
import {
  setCurrentDateLoaded,
  setUpdateRate,
} from '@shared/store/slices/events.slice';

const INCOMING_EVENTS_UPDATE_RATE = 28 * 60 * 1000;
const NEXT_HOURS_EVENTS_UPDATE_RATE = 3 * 60 * 60 * 1000;

export enum EventsRequestType {
  LEGACY = 'legacy',
  INCOMING = 'incoming',
  NEXT_HOURS = 'nextHours',
}

export default function eventsObservable(type = EventsRequestType.NEXT_HOURS) {
  // Initialize observable
  return new Observable<IEventObservable>((subscriber) => {
    // 1. Select request
    let request: () => Promise<EventMap[] | EventMap> = () =>
      Promise.resolve([]);

    switch (type) {
      case EventsRequestType.LEGACY:
        request = () => {
          store.dispatch(setCurrentDateLoaded(true));
          // const prevDayEvents = eventsRequest(DateUtils.getDateFromOffset(-1));
          const currentDayEvents = eventsRequest(DateUtils.getCurrentDate());
          // const nextDayEvents = eventsRequest(DateUtils.getDateFromOffset(1));
          return Promise.all([currentDayEvents]);
        };
        break;
      case EventsRequestType.INCOMING:
        store.dispatch(setUpdateRate(INCOMING_EVENTS_UPDATE_RATE));
        request = () => incomingEventsRequest();
        break;
      case EventsRequestType.NEXT_HOURS:
        store.dispatch(setUpdateRate(NEXT_HOURS_EVENTS_UPDATE_RATE));
        request = () => Promise.all(nextHoursEventsRequest());
        break;
    }

    // 2. Fetch events
    request()
      // Receive data from request, merge if required, and send it to subscriber
      .then((data) => {
        let events: EventMap = {};
        if (data.length) {
          events = (data as EventMap[]).reduce((prev, next) => {
            return EventUtils.mergeEvents(prev, next);
          }, {});
        } else {
          events = data as EventMap;
        }
        subscriber.next({ events });
        subscriber.complete();
      })
      // Otherwise, send error to subscriber
      .catch((e) => {
        console.error(e);
        subscriber.error();
        subscriber.complete();
      });
  });
}
